export const ADD_USER = 'ADD_USER'
export const REMOVE_USER = 'REMOVE_USER'
export const SET_DISCIPLINAS = 'SET_DISCIPLINAS'
export const SET_DISCIPLINA = 'SET_DISCIPLINA'
export const UPDATE_DISCIPLINAS = 'UPDATE_DISCIPLINAS'
export const INSERT_DISCIPLINAS = 'INSERT_DISCIPLINAS'
export const REMOVE_DISCIPLINAS = 'REMOVE_DISCIPLINAS'